import { SIGN_ORIGIN } from "../../../../common/enum/common";
import type { Page } from "../../../../common/types/base/BaseEntity";
import type { PurchaseGoodsQueryParams, PurchaseGoodsForm } from "../../../../common/types/purchaseGoods";
import { BaseService } from "./baseService";
import httpRequest from ".";
import type { PurchaseGoods, PurchaseGoodsVo } from "@zhihaoscm/entity";

export class PurchaseGoodsService extends BaseService<
    PurchaseGoods,
    PurchaseGoodsVo,
    PurchaseGoodsQueryParams,
    PurchaseGoodsForm
> {
    /**
     * 分页查询
     * @param params
     */
    // @ts-ignore
    async paging(params: any) {
        const { data } = await this.service.get(`${this.path}/customPaging`, { params });
        return data as Promise<Page<PurchaseGoods>>;
    }

    /**
     * 提货单下拉列表
     * @param projectId 项目id
     * @param type
     * @param params
     */
    async getListByProjectId(
        projectId: number,
        type: number,
        params: PurchaseGoodsQueryParams
    ): Promise<PurchaseGoods[]> {
        const { data } = await this.service.get(`${this.path}/paging/project-id/${projectId}/type/${type}`, { params });
        return data as Promise<PurchaseGoods[]>;
    }

    /**
     * 供应商关联提货单下拉列表
     */
    async getList(projectId: string): Promise<PurchaseGoods[]> {
        const { data } = await this.service.get(`${this.path}/supplier-selector`, { params: { projectId } });
        return data as Promise<PurchaseGoods[]>;
    }

    /**
     * 供应链关联提货单下拉列表
     */
    async getDownStreamList(projectId: string): Promise<PurchaseGoods[]> {
        const { data } = await this.service.get(`${this.path}/supply-chain-selector`, { params: { projectId } });
        return data as Promise<PurchaseGoods[]>;
    }

    /** 发起签署 */
    async startSign(id: string): Promise<any> {
        const { data } = await this.service.put(`${this.path}/initiateSigning/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }

    /** 签署 */
    async sign(id: string): Promise<any> {
        const { data } = await this.service.put(`${this.path}/signing/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }

    /**
     * 删除实例
     * @param id
     */
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /**
     * 创建实例
     * @param form
     */
    public async create(form: PurchaseGoodsForm): Promise<PurchaseGoods> {
        for (const key in form) {
            const value = form[key as keyof PurchaseGoodsForm];
            if (value === undefined || value === null || value === "") {
                delete form[key as keyof PurchaseGoodsForm];
            }
        }
        const { data } = await this.service.post(this.path, form, {
            loading: true
        });
        return data;
    }

    /**
     * 更新实例
     * @param id
     * @param form
     */
    public async update(id: number | string, form: PurchaseGoodsForm) {
        const { data } = await this.service.put(`${this.path}/${id}`, form, {
            loading: true
        });
        return data;
    }
    /**
     * 作废提货
     */
    async startInvalid(id: number): Promise<{
        pageUrl: string;
        ticket?: string;
        errors: unknown[];
        status: number;
    }> {
        const { data } = await this.service.put(`${this.path}/invalid/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }
}

export const purchaseGoodsService = new PurchaseGoodsService("/purchase/goods", httpRequest);
